import './styles.sass'

import React, { FC, useContext, useState, FormEvent, useEffect } from 'react';
import eyeIcon from '../../assets/icons/eye.svg'
import hideEye from '../../assets/icons/eye-slash.svg'
import { Context } from '../../index';
import Background from './Background';
import Checkbox from '../../components/UI/checkbox/ChCheckbox';
import Spinner from '../../components/UI/spinner/Spinner';


const LoginForm: FC = () => {
  const { store } = useContext(Context)
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [isShowPass, setShowPass] = useState<boolean>(false)
  const [selected, setSelected] = useState(false)
  const [error, setError] = useState<string>("")

  const [loading, setLoading] = useState(false)

  const login = (e: FormEvent) => {
    e.preventDefault();
    setLoading(true)
    store.login(email, password).then((response: any) => {
      setError(response.error.response.data.message)
      setLoading(false)
    }).catch((error) => {
      setLoading(false)
    })
  }

  return (
    <div id="loginLayout">
      <Background />
      <div className="login-form">
        <div className="title">Welcome back</div>
        <form onSubmit={login} className="form">
          <div className="input-group">
            <label htmlFor="email">
              <span className="input-container">
                <span className='label'>Email</span>
                <input className="input" type="text" id='email' onChange={e => setEmail(e.target.value)} value={email}
                />
              </span>

            </label>
            <label htmlFor="password">
              <span className="input-container">
                <span className="label">Password</span>
                <input className="input"
                  type={isShowPass ? 'text' : 'password'}
                  id="password"
                  onChange={e => setPassword(e.target.value)}
                  value={password} />
                <span
                  className={`btn-show-pass icon ${isShowPass ? 'show' : ''}`}
                  onClick={() => setShowPass(!isShowPass)}>
                  {isShowPass ?
                    <img src={hideEye} alt="hide password" />
                    : <img src={eyeIcon} alt="show password" />}
                </span>
              </span>
            </label>
          </div>
          <div style={{marginBottom:"0.5rem"}}>
          <small style={{
              color: "red",
            }}>
              {error && error}
            </small>
          </div>
          <div className="login">
            {/* <Checkbox
              label='Remember me'
              id='remember'
              name='remember'
              onChange={setSelected}
            /> */}
            <button className="button" onClick={login}>{!loading ? "Login" : <Spinner style={{height:"1rem"}}/>}</button>
          </div>
        </form>
      </div >
    </div >
  );
};

export default LoginForm;
